
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/policy-administration",
      function () {
        return require("private-next-pages/solutions/policy-administration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/policy-administration"])
      });
    }
  